import React from 'react';
import PropTypes from 'prop-types';
import JobModule from 'modules/job';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';

class JobDetailEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChanged: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.constant.fetchList());
    this.setState({ isChanged: this.props.isChanged });
  }

  _isAllowedToAddTask() {
    const { form } = this.props;
    if (
      Utils.Helper.isNonEmptyString(form.base_task_attributes.address_attributes.country)
        && Utils.Helper.isNonEmptyString(form.base_task_attributes.address_attributes.line_1)
        && Utils.Helper.isNonEmptyString(form.base_task_attributes.time_from)
    ) {
      // Point-to-Point job types have limitations such that only one task is allowed per job
      if (form.job_type === 'p2p') {
        return form.tasks_attributes.length < 1;
      }
      return true;
    }

    return false;
  }

  _getAccountOptions() {
    let accountOptions = [];

    if (this.props.customer && typeof this.props.customer.billing_accounts !== 'undefined') {
      accountOptions = this.props.customer.billing_accounts.map(account => ({
        value: account.id,
        text: account.name,
      }));
    }
    return accountOptions;
  }

  _renderRightPanel() {
    return (
      <Components.Form.RightPanel>
        {this.props.form.tasks_attributes.length > 0 ? (
          <Components.Form.MainButton id="vf-job__new-form__job-form__right-panel__save-button" onClick={this.props.save}>
            {this.props.strings.Job.form.buttons.save}
          </Components.Form.MainButton>
        ) : false}
        <Components.Button
          disabled={!this._isAllowedToAddTask()}
          iconClassName="versa-add"
          id="vf-job__new-form__job-form__right-panel__add-task-button"
          onClick={() => {
            this.props.setTaskIndex(null);
            this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
          }}
        >
          {this.props.strings.Job.form.buttons.addTask}
        </Components.Button>
      </Components.Form.RightPanel>
    );
  }

  render() {
    const accountOptions = this._getAccountOptions();

    return (
      <Components.Form.CoreLayout
        className="vf-job__mobile-new-form__job-detail"
        isChanged={this.state.isChanged}
        onClose={() => (this.props.location.pathname.includes('submissions')
          ? this.props.navigate('/submissions')
          : this.props.navigate('/in_progress'))}
        rightPanel={this._renderRightPanel()}
        title={(
          <Components.Form.Title>
            <Components.Form.Title.Item isHighlighted>
              {this.props.form.job_type === 'pickup'
                ? this.props.strings.Job.form.menu.jobDeliveryInfo
                : this.props.strings.Job.form.menu.jobPickupInfo}
            </Components.Form.Title.Item>
            <Components.Form.Title.Item>
              {this.props.form.job_type === 'pickup'
                ? this.props.strings.Job.form.menu.pickupTaskInfo
                : this.props.strings.Job.form.menu.deliveryTaskInfo}
            </Components.Form.Title.Item>
          </Components.Form.Title>
        )}
      >
        <JobModule.Edit
          constant={this.props.constant}
          customer={this.props.customer}
          data={this.props.form}
          error={this.props.error}
          form={this.props.form}
          id="vf-job__new-form__job-form__left-panel"
          onFormChange={(fieldName, value) => {
            if (!this.state.isChanged) {
              this.setState({ isChanged: true });
            }
            this.props.onFormChange(fieldName, value);
          }}
          optionAddresses={this.props.optionAddresses}
        />

        <div className="vf-job__detail__tasks">
          {`${(this.props.form.job_type === 'pickup' ? this.props.strings.Job.form.task.pickupTask
            : this.props.strings.Job.form.task.deliveryTask)} (${this.props.form.tasks_attributes.length})`}
          {this._isAllowedToAddTask() ? (
            <Components.Button
              className="vf-job__detail__tasks__button-add"
              iconClassName="versa-add"
              id="vf-job__new-form__job-form__left-panel__add-task-button"
              onClick={() => {
                this.props.setTaskIndex(null);
                this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
              }}
            >
              {this.props.strings.Job.form.buttons.addTask}
            </Components.Button>
          ) : false}
        </div>

        {this.props.form.tasks_attributes.map((t, i) => {
          let accountName;
          const account = accountOptions.filter(o => o.value === t.billing_account_id);
          if (account.length > 0) {
            accountName = account[0].text;
          } else {
            accountName = this.props.strings.Task.form.constants.noAccount;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className="vf-job__mobile-new-form__job-detail__task-item" key={`task-item-${i}`}>
              <div className="vf-job__mobile-new-form__job-detail__task-item__index">
                {`${i + 1}.`}
              </div>
              <div
                className="vf-job__mobile-new-form__job-detail__task-item__content"
                onClick={() => {
                  this.props.setTaskIndex(i);
                  this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
                }}
              >
                <div className="vf-job__mobile-new-form__job-detail__task-item__content__name">
                  {accountName}
                </div>
                <div className="vf-job__mobile-new-form__job-detail__task-item__content__guid">
                  {t.guid}
                </div>
              </div>
            </div>
          );
        })}
      </Components.Form.CoreLayout>
    );
  }
}

JobDetailEdit.propTypes = {
  constant: PropTypes.shape().isRequired,
  customer: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape({}),
  form: PropTypes.shape({
    base_task_attributes: PropTypes.shape(),
    job_type: PropTypes.oneOf(['delivery', 'pickup', 'p2p']),
    tasks_attributes: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  isChanged: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  save: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setTaskIndex: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          save: PropTypes.string,
          addTask: PropTypes.string,
        }),
        menu: PropTypes.shape({
          jobDeliveryInfo: PropTypes.string,
          jobPickupInfo: PropTypes.string,
          pickupTaskInfo: PropTypes.string,
          deliveryTaskInfo: PropTypes.string,
        }),
        task: PropTypes.shape({
          pickupTask: PropTypes.string,
          deliveryTask: PropTypes.string,
        }),
      }),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        constants: PropTypes.shape({
          noAccount: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobDetailEdit.defaultProps = {
  error: {},
  isChanged: false,
};

const mapStateToProps = (state) => {
  const { profile, constant } = state;
  return {
    constant: constant.constant,
    customer: profile.profile,
    optionAddresses: [],
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(JobDetailEdit)));
